// store/modules/patientList.js
const state = {
    query: null,    // 搜索条件，例如 keyword
    page: 0,        // 当前页码
    list: [],       // 列表数据
    scrollTop: 0    // 滚动位置
}

const mutations = {
    SET_QUERY(state, payload) {
        state.query = payload
    },
    SET_PAGE(state, page) {
        state.page = page
    },
    SET_LIST(state, list) {
        state.list = list
    },
    SET_SCROLL_TOP(state, top) {
        state.scrollTop = top
    }
}

const actions = {
    saveQuery({ commit }, payload) {
        commit('SET_QUERY', payload)
    },
    savePage({ commit }, page) {
        commit('SET_PAGE', page)
    },
    saveList({ commit }, list) {
        commit('SET_LIST', list)
    },
    saveScrollTop({ commit }, top) {
        commit('SET_SCROLL_TOP', top)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
